import { Text, View } from "@react-pdf/renderer";
import { styles } from "../styles";
import {
	calculoExcedente,
	converteUnidades,
	formatToBrazilianCurrency,
	getDecimalPrecision,
	tarifacaoMBitsPorSegundo,
} from "../../../utils/flowReport";

export function TableReport({ relatorio, show }) {
	// *** Bases para os cálculos ***
	const refPrice = relatorio?.tarifacaoExcedente?.valor;
	const refSurplusPrice = relatorio?.tarifacaoExcedente?.valorExcedente;
	const refSurplusLimit = relatorio?.tarifacaoExcedente?.limite;
	const refTh95 = relatorio?.analysis?.th95;
	const surplusBilling = relatorio?.tarifacaoExcedente?.status;

	// *** Valores a serem exibidos ***
	const priceMbps = refPrice?.toFixed(getDecimalPrecision(refPrice)) ?? 0;

	const surplusPriceMbps =
		refSurplusPrice?.toFixed(getDecimalPrecision(refSurplusPrice)) ?? 0;

	const surplusLimit = refSurplusLimit
		? parseFloat(refSurplusLimit) * Math.pow(10, 6)
		: 0;

	const trafficFull = refTh95 ? parseFloat(refTh95?.replace(" bps")) : "";

	const valueWithoutSurplusLimit =
		trafficFull <= surplusLimit && !!refTh95 ? refTh95 : surplusLimit;

	const surplusLimitValue =
		trafficFull - surplusLimit < 0 ? 0 : trafficFull - surplusLimit;

	const totalValue =
		!!refTh95 && !!surplusBilling
			? Math.max(
					calculoExcedente(
						priceMbps,
						refTh95,
						surplusPriceMbps,
						refSurplusLimit
					),
					priceMbps * refSurplusLimit
			  )
			: Math.max(
					tarifacaoMBitsPorSegundo(priceMbps, trafficFull),
					priceMbps * refSurplusLimit
			  );

	return (
		<View style={styles.tableDescription}>
			{/* Cabeçalho */}
			<View style={styles.tableDescriptionHeader}>
				<Text>Descrição</Text>
				<Text>Valor</Text>
			</View>

			{/* Linhas da Tabela */}
			{!!show?.min && relatorio?.analysis?.min >= 0 && (
				<View style={styles.tableDescriptionRow}>
					<Text>Menor Consumo</Text>
					<Text>{`${converteUnidades(relatorio?.analysis?.min, "bps")}`}</Text>
				</View>
			)}
			{!!show?.avg && !!relatorio?.analysis?.avg >= 0 && (
				<View style={styles.tableDescriptionRow}>
					<Text>Consumo Médio</Text>
					<Text>{`${converteUnidades(relatorio?.analysis?.avg, "bps")}`}</Text>
				</View>
			)}
			{!!show?.max && relatorio?.analysis?.max >= 0 && (
				<View style={styles.tableDescriptionRow}>
					<Text>Maior Consumo</Text>
					<Text>{`${converteUnidades(relatorio?.analysis?.max, "bps")}`}</Text>
				</View>
			)}
			{!!show?.charge && priceMbps >= 0 && (
				<View style={styles.tableDescriptionRow}>
					<Text>Preço por Mbps</Text>
					<Text>{`R$ ${formatToBrazilianCurrency(priceMbps)}`}</Text>
				</View>
			)}
			{surplusBilling && (
				<>
					{!!show?.charge && surplusPriceMbps >= 0 && (
						<View style={styles.tableDescriptionRow}>
							<Text>Preço por Mbps de tráfego excedente</Text>
							<Text>{`R$ ${formatToBrazilianCurrency(surplusPriceMbps)}`}</Text>
						</View>
					)}
					{!!show?.charge && (
						<View style={styles.tableDescriptionRow}>
							<Text>Limite de tráfego sem cobrança de excedente</Text>
							<Text>{`${converteUnidades(surplusLimit, "bps")}`}</Text>
						</View>
					)}
					{!!refTh95 && !!show?.percentile && (
						<View style={styles.tableDescriptionRow}>
							<Text>Tráfego 95th percentil</Text>
							<Text>{`${converteUnidades(refTh95, "bps")}`}</Text>
						</View>
					)}
					{!!show?.charge && priceMbps >= 0 && (
						<View style={styles.tableDescriptionRow}>
							<Text>Valor sem adicional de excedente</Text>
							<Text>{`${Math.max(
								tarifacaoMBitsPorSegundo(valueWithoutSurplusLimit, priceMbps),
								priceMbps * refSurplusLimit
							).toLocaleString("pt-br", {
								style: "currency",
								currency: "BRL",
							})}`}</Text>
						</View>
					)}
					{!!show?.charge && surplusPriceMbps >= 0 && (
						<View style={styles.tableDescriptionRow}>
							<Text>Valor do excedente</Text>
							<Text style={{ color: "#FB9904" }}>{`${tarifacaoMBitsPorSegundo(
								surplusLimitValue,
								surplusPriceMbps
							).toLocaleString("pt-br", {
								style: "currency",
								currency: "BRL",
							})}`}</Text>
						</View>
					)}
				</>
			)}

			{/* Valor Total */}
			{!!show?.charge && totalValue >= 0 && (
				<View style={styles.tableDescriptionSum}>
					<Text>Valor Total</Text>
					<Text>{`${totalValue.toLocaleString("pt-br", {
						style: "currency",
						currency: "BRL",
					})}`}</Text>
				</View>
			)}
		</View>
	);
}
